import React, { createContext, useCallback, useState, useContext } from 'react';

type AppProviderProps = {
	children: React.ReactNode;
}
type ProdutoDATA = {
  id: string;
  cod_barras: string;
  classif: number;
  nome: string;
  descricao: string;
  valor: number;
  imagem: any;
  url_imagem: string;
  grupos: GrupoDATA[];
  remove_azure: boolean;
  venda_delivery: boolean;
  venda_local: boolean;
  destaque_delivery: boolean;
  destaque_local: boolean;
  sku: string;
  ativo: string;
}
type GrupoDATA = {
  id: string;
  nome: string;
  obrigatorio: string;
  min_itens: number;
  max_itens: number;
  complementos: ComplementosDATA[];
}
type ComplementosDATA = {
  cod: string;
  nome: string;
  descricao: string;
  valor: number;
  qtd_gratis: number;
  qtd_maxima: number;
}
interface ProdutoHookState {
  produto: ProdutoDATA;
}
interface ProdutoHookContexData {
  produto: ProdutoDATA;
  setHookProduto(data: ProdutoDATA): void;
  resetHookProduto(): void;
  addHookGrupo(data: GrupoDATA): void;
  setHookGrupo(grupo: GrupoDATA): void;
  removeHookGrupo(grupo: GrupoDATA): void;
  addHookComplemento(id_grupo: string, comp: ComplementosDATA): void;
}

const ProdutoHookContext = createContext<ProdutoHookContexData>(
  {} as ProdutoHookContexData,
);

const ProdutoHookProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [produto, setProduto] = useState<ProdutoDATA>({
    id: '',
    cod_barras: '',
    classif: 0,
    nome: '',
    descricao: '',
    valor: 0,
    imagem: '',
    url_imagem: '',
    grupos: [],
    remove_azure: false,
    venda_delivery: true,
    venda_local: true,
    destaque_delivery: false,
    destaque_local: false,
    sku: '',
    ativo: 'S',
  });
  const [data, setData] = useState<ProdutoHookState>(() => {
    return {} as ProdutoHookState;
  });

  const setHookProduto = useCallback((prod: ProdutoDATA) => {
    setProduto(prod);
    setData({
      produto: prod,
    });
  }, []);

  const resetHookProduto = useCallback(() => {
    const auxProduto = {
      id: '',
      cod_barras: '',
      classif: 0,
      nome: '',
      descricao: '',
      valor: 0,
      imagem: '',
      url_imagem: '',
      grupos: [],
      remove_azure: false,
      venda_delivery: true,
      venda_local: true,
      destaque_delivery: false,
      destaque_local: false,
      sku: '',
      ativo: 'S',
    };

    setProduto(auxProduto);
    setData({
      produto: auxProduto,
    });
  }, []);

  const addHookGrupo = useCallback(
    (grupo: GrupoDATA) => {
      const auxProduto = produto;

      if (!auxProduto.grupos) {
        auxProduto.grupos = [];
      }

      auxProduto.grupos.push(grupo);

      setProduto(auxProduto);
      setData({
        produto: auxProduto,
      });
    },
    [produto],
  );

  const setHookGrupo = useCallback(
    (grupo: GrupoDATA) => {
      const auxProduto = produto;

      const indexGrupo = auxProduto.grupos.findIndex(
        item => item.id === grupo.id,
      );

      auxProduto.grupos[indexGrupo] = grupo;

      setProduto(auxProduto);
      setData({
        produto: auxProduto,
      });
    },
    [produto],
  );
  const removeHookGrupo = useCallback(
    (grupo: GrupoDATA) => {
      const auxProduto = produto;

      const indexGrupo = auxProduto.grupos.findIndex(
        item => item.id === grupo.id,
      );

      auxProduto.grupos.splice(indexGrupo, 1);

      setProduto(auxProduto);
      setData({
        produto: auxProduto,
      });
    },
    [produto],
  );

  const addHookComplemento = useCallback(
    (id_grupo: string, comp: ComplementosDATA) => {
      const auxProduto = produto;

      const indexgrupo = auxProduto.grupos.findIndex(
        item => item.id === id_grupo,
      );

      auxProduto.grupos[indexgrupo].complementos.push(comp);

      setProduto(auxProduto);
      setData({
        produto: auxProduto,
      });
    },
    [produto],
  );

  return (
    <ProdutoHookContext.Provider
      value={{
        produto: data.produto,
        setHookProduto,
        resetHookProduto,
        addHookGrupo,
        setHookGrupo,
        removeHookGrupo,
        addHookComplemento,
      }}
    >
      {children}
    </ProdutoHookContext.Provider>
  );
};

function useProdutoHook(): ProdutoHookContexData {
  const context = useContext(ProdutoHookContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { ProdutoHookProvider, useProdutoHook };
